import { forwardRef } from 'react';
import BaseIconStyled from '../style';

const DownloadIcon = forwardRef(({ children, color, variant, ...props }, ref) => {
  return (
    <BaseIconStyled viewBox="0 0 10 12" fill="none" {...props}>
      <path d="M1 11L8.5 11" stroke="white"/>
      <path d="M4 1C4 0.585786 4.33579 0.25 4.75 0.25C5.16421 0.25 5.5 0.585786 5.5 1L4 1ZM4.75 8.5L5.28033 9.03033C4.98744 9.32322 4.51256 9.32322 4.21967 9.03033L4.75 8.5ZM6.40717 5.78217C6.70006 5.48928 7.17494 5.48928 7.46783 5.78217C7.76072 6.07506 7.76072 6.54994 7.46783 6.84283L6.40717 5.78217ZM2.03217 6.84283C1.73928 6.54994 1.73928 6.07506 2.03217 5.78217C2.32506 5.48928 2.79994 5.48928 3.09283 5.78217L2.03217 6.84283ZM5.5 1L5.5 8.5H4L4 1L5.5 1ZM4.21967 7.96967L6.40717 5.78217L7.46783 6.84283L5.28033 9.03033L4.21967 7.96967ZM4.21967 9.03033L2.03217 6.84283L3.09283 5.78217L5.28033 7.96967L4.21967 9.03033Z" fill="white"/>
    </BaseIconStyled>
  );
});

export default DownloadIcon;
